import axios from "axios";

export async function fetchTargetGroupsLvl1() {
    try {
        const response = await axios.get("/targetGroups/level1");
        return response.data.targetGroups;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка загрузки целевых групп";
        throw new Error(text);
    }
}
